import React from "react";
import Carousel from "./Carousel";
import About from "./About";
import Client from "./Client";

import about1 from "../../assets/img/about-1.jpg";
import team2 from "../../assets/img/team-2.jpg";
import team1 from "../../assets/img/team-1.jpg";
import team3 from "../../assets/img/team-3.jpg";
import team4 from "../../assets/img/team-4.jpg";
import ourservice1 from "../../assets/img/platform.png";
import ourservice2 from "../../assets/img/monitor.png";
import ourservice3 from "../../assets/img/shield-2.png";
import ourservice4 from "../../assets/img/management.png";


function Home() {
  return (
    <>
      <Carousel />

      {/* <div class="container-fluid facts py-5 pt-lg-0">
        <div class="container py-5 pt-lg-0">
          <div class="row gx-0">
            <div class="col-lg-4 wow fadeIn" data-wow-delay="0.1s">
              <div
                class="bg-white shadow d-flex align-items-center h-100 p-4"
                style={{ minHeight: "150px" }}
              >
                <div class="d-flex">
                  <div class="flex-shrink-0 btn-lg-square bg-primary">
                    <i class="fa fa-car text-white"></i>
                  </div>
                  <div class="ps-4">
                    <h5>Easy Driving Learn </h5>
                    <span>
                      Clita erat ipsum lorem sit sed stet duo justo erat amet
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 wow fadeIn" data-wow-delay="0.3s">
              <div
                class="bg-white shadow d-flex align-items-center h-100 p-4"
                style={{ minHeight: "150px" }}
              >
                <div class="d-flex">
                  <div class="flex-shrink-0 btn-lg-square bg-primary">
                    <i class="fa fa-users text-white"></i>
                  </div>
                  <div class="ps-4">
                    <h5>National Instructor</h5>
                    <span>
                      Clita erat ipsum lorem sit sed stet duo justo erat amet
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 wow fadeIn" data-wow-delay="0.5s">
              <div
                class="bg-white shadow d-flex align-items-center h-100 p-4"
                style={{ minHeight: "150px" }}
              >
                <div class="d-flex">
                  <div class="flex-shrink-0 btn-lg-square bg-primary">
                    <i class="fa fa-file-alt text-white"></i>
                  </div>
                  <div class="ps-4">
                    <h5>Get licence</h5>
                    <span>
                      Clita erat ipsum lorem sit sed stet duo justo erat amet
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <About />

      <div class="container-xxl courses my-6 py-6 pb-0">
        <div class="container">
          <div
            class="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
           // style={{ minWidth: "500px" }}
          >
            <h6 class="text-primary text-uppercase mb-2">Our Services</h6>
            <h1 class="display-6 mb-4">
              Revtech's technology services for the modern business.
            </h1>
            <p>Revtech's technology services are designed for the modern business.
            We empower you to navigate the ever-evolving digital landscape, unlocking innovation and maximizing your potential.</p>
          </div>
          <div class="row g-4 justify-content-center">
            <div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    {/* <i class="fa fa-trophy" aria-hidden="true"></i> */}
                    <img src={ourservice1} height={50} width={50}/>
                  </div>
                  <h5 class="mb-3">Technology & Infrastructure Management</h5>
                  <p>
                  Our experts manage your cloud, infrastructure, and automation, ensuring a smooth-running and secure foundation for your business. Let Revtech handle the IT complexities, freeing you to dedicate your resources to strategic initiatives and growth.
                  </p>
                  {/* <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol> */}
                </div>
                {/* <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses1} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
            <div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    {/* <i class="fa fa-mobile" aria-hidden="true"></i> */}
                    <img src={ourservice2} height={50} width={50}/>
                    
                  </div>
                  <h5 class="mb-3">Data & Analytics</h5>
                  <p>
                  Leverage AI, data analysis, and generative AI to extract valuable insights, gain a competitive edge, and make data-driven decisions. Our data experts help you translate information into strategies that drive innovation and improve business outcomes.
                  </p>
                  {/* <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol> */}
                </div>
                {/* <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses2} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
            <div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    {/* <i class="fa fa-television" aria-hidden="true"></i> */}
                    <img src={ourservice3} height={50} width={50}/>
                  </div>
                  <h5 class="mb-3">Security & Compliance</h5>
                  <p>
                  Our robust cybersecurity solutions and digital assurance practices ensure your data and systems are secure and compliant.Partner with Revtech to mitigate risk and foster a secure environment for your business and your clients.
                  </p>
                  {/* <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol> */}
                </div>
                {/* <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses3} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
            <div class="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    <img src={ourservice4} height={50} width={50}/>
                  </div>
                  <h5 class="mb-3">HR & Business Operations</h5>
                  <p>
                  Revtech's staffing and payroll services connect you with the best people and streamline HR processes, maximizing your human capital.Our HR and business operations expertise helps you build a high-performing team and optimize your business for growth.
                  </p>
                  {/* <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol> */}
                </div>
                {/* <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses1} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    <i class="fa fa-mobile" aria-hidden="true"></i>
                  </div>
                  <h5 class="mb-3">Highway Driving Lesson</h5>
                  <p>
                    Tempor erat elitr rebum at clita dolor diam ipsum sit diam
                    amet diam et eos
                  </p>
                  <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol>
                </div>
                <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses2} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="courses-item d-flex flex-column bg-white overflow-hidden h-100">
                <div class="text-center p-4 pt-0">
                  <div class="d-inline-block bg-primary text-white fs-5 py-1 px-4 mb-4">
                    <i class="fa fa-television" aria-hidden="true"></i>
                  </div>
                  <h5 class="mb-3">International Driving</h5>
                  <p>
                    Tempor erat elitr rebum at clita dolor diam ipsum sit diam
                    amet diam et eos
                  </p>
                  <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item small">
                      <i class="fa fa-signal text-primary me-2"></i>Beginner
                    </li>
                    <li class="breadcrumb-item small">
                      <i class="fa fa-calendar-alt text-primary me-2"></i>3 Week
                    </li>
                  </ol>
                </div>
                <div class="position-relative mt-auto">
                  <img class="img-fluid" src={courses3} alt="" />
                  <div class="courses-overlay">
                    <a class="btn btn-outline-primary border-2" href="">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div class="col-lg-8 my-6 mb-0 wow fadeInUp" data-wow-delay="0.1s">
              <div class="bg-primary text-center p-5">
                <h1 class="mb-4">Make Appointment</h1>
                <form>
                  <div class="row g-3">
                    <div class="col-sm-6">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control border-0"
                          id="gname"
                          placeholder="Gurdian Name"
                        />
                        <label for="gname">Your Name</label>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-floating">
                        <input
                          type="email"
                          class="form-control border-0"
                          id="gmail"
                          placeholder="Gurdian Email"
                        />
                        <label for="gmail">Your Email</label>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control border-0"
                          id="cname"
                          placeholder="Child Name"
                        />
                        <label for="cname">Courses Type</label>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-floating">
                        <input
                          type="text"
                          class="form-control border-0"
                          id="cage"
                          placeholder="Child Age"
                        />
                        <label for="cage">Car Type</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-floating">
                        <textarea
                          class="form-control border-0"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ Height: "100px" }}
                        ></textarea>
                        <label for="message">Message</label>
                      </div>
                    </div>
                    <div class="col-12">
                      <button class="btn btn-dark w-100 py-3" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div class="container-xxl py-6">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <h6 class="text-primary text-uppercase mb-2">Our Technologies</h6>
              <h1 class="display-6 mb-4">
                We pioneer the use of cutting-edge technologies
              </h1>
              <p class="mb-5">
              Our steadfast commitment to leveraging cutting-edge technology and
              tools enables us to deliver exceptional solutions and services to our valued clients.
              </p>
              <div class="row gy-4 gx-4">
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Data Scientist/AI</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Cloud Computing</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Software Engineer</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Machine learning</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Power Platform</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.6s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Databricks</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Cyber Security Engineer</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.8s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Solution Architect</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
                <div class="col-sm-6 wow fadeIn" data-wow-delay="0.9s">
                  <div class="d-flex align-items-center mb-3">
                    <div class="flex-shrink-0 btn-sm-square bg-primary me-3">
                      <i class="fa fa-check text-white"></i>
                    </div>
                    <h5 class="mb-0">Service Now</h5>
                  </div>
                  {/* <span>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  </span> */}
                </div>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.10s">
              <div
                class="position-relative overflow-hidden pe-5 pt-5 h-100"
                style={{ minHeight: "400px" }}
              >
                <img
                  class="position-absolute w-100 h-100"
                  src={about1}
                  alt=""
               
                />
                {/* <img
                  class="position-absolute top-0 end-0 bg-white ps-3 pb-3"
                  src={about2}
                  alt=""
                  style={{ height: "200px", width: "200px" }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="container-xxl py-6">
        <div class="container">
          <div
            class="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s">
            <h6 class="text-primary text-uppercase mb-2">Our Client</h6>
            <h6 class="display-6 mb-4">
              Our clients are our top priority, and we are committed to
              providing them with the highest level of service.
            </h6>
          </div>
          <div class="row g-0 team-items">
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="team-item position-relative">
                <div class="position-relative">
                  <img class="img-fluid" src={team1} alt="" />
                  <div class="team-social text-center">
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div class="bg-light text-center p-4">
                  <h5 class="mt-2">Full Name</h5>
                  <span>Trainer</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div class="team-item position-relative">
                <div class="position-relative">
                  <img class="img-fluid" src={team2} alt="" />
                  <div class="team-social text-center">
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div class="bg-light text-center p-4">
                  <h5 class="mt-2">Full Name</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="team-item position-relative">
                <div class="position-relative">
                  <img class="img-fluid" src={team3} alt="" />
                  <div class="team-social text-center">
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div class="bg-light text-center p-4">
                  <h5 class="mt-2">Full Name</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
              <div class="team-item position-relative">
                <div class="position-relative">
                  <img class="img-fluid" src={team4} alt="" />
                  <div class="team-social text-center">
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a
                      class="btn btn-square btn-outline-primary border-2 m-1"
                      href=""
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div class="bg-light text-center p-4">
                  <h5 class="mt-2">Full Name</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Client/>
    </>
  );
}

export default Home;
